"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNodeConfig = exports.NodeConfig = void 0;
var tslib_1 = require("tslib");
var analytics_core_1 = require("@amplitude/analytics-core");
var http_1 = require("./transports/http");
var NodeConfig = /** @class */ (function (_super) {
    tslib_1.__extends(NodeConfig, _super);
    function NodeConfig(apiKey, options) {
        return _super.call(this, tslib_1.__assign(tslib_1.__assign({ transportProvider: new http_1.Http() }, options), { apiKey: apiKey })) || this;
    }
    return NodeConfig;
}(analytics_core_1.Config));
exports.NodeConfig = NodeConfig;
var useNodeConfig = function (apiKey, overrides) {
    return new NodeConfig(apiKey, overrides);
};
exports.useNodeConfig = useNodeConfig;
//# sourceMappingURL=config.js.map